module.exports = __webpack_public_path__ + "img/16.43544a23.png";